<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid mb-4">
      <div class="row">
        <div class="col-12">
          <div class="w-100 d-flex align-items-center justify-content-center">
            <div class="login-wrapper p-4">
              <h2 class="modal-text">Tukar kata laluan</h2>
              <div class="w-100 mt-4">
                <!-- reset password form -->
                <vue-form
                  :state="formstate"
                  @submit.prevent="onSubmit"
                  v-if="!tokenAvailable"
                >
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.password)"
                  >
                    <label class="w-100 text-gray text-left">Kata laluan</label>
                    <input
                      type="password"
                      password-strength
                      name="password"
                      class="form-control"
                      required
                      v-model.lazy="model.password"
                    />

                    <field-messages
                      auto-label
                      name="password"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div class="error" slot="required">
                        Sila masukkan kata laluan
                      </div>
                      <div class="error" slot="password-strength">
                        Kata laluan memerlukan Huruf Besar, Huruf Kecil,
                        Nombor/SpecialChar dan min 8 Huruf
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.confirmPassword)"
                  >
                    <label class="w-100 text-gray text-left"
                      >Pengesahan Kata laluan</label
                    >
                    <input
                      type="password"
                      :matches="model.password"
                      name="confirmPassword"
                      class="form-control"
                      required
                      v-model.lazy="model.confirmPassword"
                    />

                    <field-messages
                      auto-label
                      name="confirmPassword"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div class="error" slot="required">
                        Sila isi pengesahan kata laluan
                      </div>
                      <div slot="matches" class="error">
                        Kata laluan tidak sama
                      </div>
                    </field-messages>
                  </validate>

                  <div class="w-100 my-2 error" v-if="errorMsg">
                    {{ errorMsg }}
                  </div>
                  <div class="py-2 text-center">
                    <button class="modal-default-button" type="submit">
                      Hantar
                    </button>
                  </div>
                </vue-form>

                <!-- change password  -->
                <vue-form
                  :state="formstateReset"
                  @submit.prevent="onSubmit"
                  v-else
                >
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstateReset.currentPassword)"
                  >
                    <label class="w-100 text-gray text-left"
                      >Kata laluan semasa</label
                    >
                    <input
                      type="password"
                      password-strength
                      name="currentPassword"
                      class="form-control"
                      required
                      v-model.lazy="model.currentPassword"
                    />

                    <field-messages
                      auto-label
                      name="currentPassword"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div class="error" slot="required">
                        Sila masukkan kata laluan
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstateReset.resetPassword)"
                  >
                    <label class="w-100 text-gray text-left"
                      >Kata laluan baru</label
                    >
                    <input
                      type="password"
                      password-strength
                      name="resetPassword"
                      class="form-control"
                      required
                      v-model.lazy="model.resetPassword"
                    />

                    <field-messages
                      auto-label
                      name="resetPassword"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div class="error" slot="required">
                        Sila masukkan kata laluan
                      </div>
                      <div class="error" slot="password-strength">
                        Kata laluan memerlukan Huruf Besar, Huruf Kecil,
                        Nombor/SpecialChar dan min 8 Huruf
                      </div>
                    </field-messages>
                  </validate>

                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstateReset.resetConfirmPassword)"
                  >
                    <label class="w-100 text-gray text-left"
                      >Pengesahan Kata laluan</label
                    >
                    <input
                      type="password"
                      :matches="model.resetPassword"
                      name="resetConfirmPassword"
                      class="form-control"
                      required
                      v-model.lazy="model.resetConfirmPassword"
                    />

                    <field-messages
                      auto-label
                      name="resetConfirmPassword"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div class="error" slot="required">
                        Sila isi pengesahan kata laluan
                      </div>
                      <div slot="matches" class="error">
                        Kata laluan tidak sama
                      </div>
                    </field-messages>
                  </validate>
                  <div class="py-2 text-center">
                    <button class="modal-default-button" type="submit">
                      Hantar
                    </button>
                  </div>
                </vue-form>
              </div>
              <div class="w-100 my-2 error" v-if="errorResetMsg">
                {{ errorResetMsg }}
              </div>
              <div class="w-100 my-2 success" v-if="successResetMsg">
                Penukaran kata laluan telah berjaya.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
export default {
  data() {
    return {
      formstate: {},
      formstateReset: {},
      errorMsg: "",
      errorResetMsg: "",
      successMsg: false,
      successResetMsg: false,
      model: {
        password: "",
        confirmPassword: "",
        currentPassword: "",
        resetPassword: "",
        resetConfirmPassword: "",
      },
      tokenAvailable: false,
    };
  },
  methods: {
    fieldClassName(field) {
      if (!field) {
        return "";
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return "has-success";
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return "has-danger";
      }
    },
    onSubmit: function(e) {
      e.preventDefault();

      const token = this.$route.params.token;

      if (this.tokenAvailable) {
        const authToken = localStorage.getItem("token");
        const userId = localStorage.getItem("user_id");
        const currentPassword = this.model.currentPassword;
        const newPassword = this.model.resetPassword;

        let vm = this;
        let body = {
          temporaryToken: token,
          existingPassword: currentPassword,
          password: newPassword,
        };
        const config = {
          headers: { "X-Auth-Token": `${authToken}` },
        };

        axios
          .put(
            `https://rtm.glueapi.io/v1/user/${userId}/password-change`,
            body,
            config
          )
          .then((response) => {
            if (response.status == 200 || response.status == "200") {
              this.successResetMsg = true;
            }
            vm.errorResetMsg = "";
          })
          .catch(function(error) {
            // vm.errorMsg = error
            vm.errorResetMsg = error.response.data.error.errors[0].message;
          });

        // $.ajax({
        //   type: "PUT",
        //   url: `https://rtm.glueapi.io/v1/user/${userId}/password-change`,
        //   contentType: "application/json",
        //   headers: {
        //     "X-Auth-Token": `${authToken}`,
        //   },
        //   data: JSON.stringify({
        //     temporaryToken: token,
        //     existingPassword: currentPassword,
        //     password: newPassword,
        //   }),
        //   dataType: "json",
        //   success: function(data) {
        //     // console.log(data);
        //     if (data.status == 200 || data.status == "200") {
        //       this.successMsg = true;
        //     }
        //   },
        //   failure: function(errMsg) {
        //     console.log(errMsg);
        //     this.errorMsg = errMsg;
        //   },
        // });
      } else {
        let vm = this;
        let body = {
          temporaryToken: vm.$route.params.token,
          password: vm.model.password,
        };

        axios
          .put(`https://rtm.glueapi.io/v1/user/password-change`, body)
          .then((response) => {
            if (response.status == 200 || response.status == "200") {
              vm.$router.push("/login");
              vm.errorMsg = "";
            }
            vm.errorMsg = "";
          })
          .catch(function(error) {
            // vm.errorMsg = error
            vm.errorMsg = error.response.data.error.errors[0].message;
          });
      }
    },
    initCheck() {
      const token = localStorage.getItem("token");
      if (token) {
        this.tokenAvailable = true;
      } else {
        this.tokenAvailable = false;
      }
    },
  },
  beforeMount() {
    this.initCheck();
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 9rem 0 0;
  min-height: 80vh;
}
.breadCrumbsWrapper {
  padding: 30px;
}
.modal-text {
  margin-top: 0;
  font-size: 30px;
  font-weight: bolder;
  line-height: 1.2;
  color: #dae12f;
}
.modal-text-small {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  color: #dae12f;
}
.signup-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #dae12f;
}
.login-wrapper {
  width: 100%;
  max-width: 480px;
  /* background: #111319; */
  border-radius: 4px;
}
.text-yellow {
  color: #dae12f;
}
.text-black {
  color: black;
}
.text-gray {
  color: #6c757d;
}
.form-label {
  display: block;
  margin-bottom: 1em;
  font-size: 14px;
  color: black;
  text-align: left;
}
.form-title {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #dae12f;
}
.form-control:focus {
  color: #7a7e83;
  background-color: #111319;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
.form-label > .form-control {
  margin-top: 0.5em;
}
.form-group label {
  text-align: left;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: none;
  border-bottom: 1px solid #707070;
  border-radius: unset;
  background: #111319;
}
.required-field > label::after {
  content: "*";
  color: red;
  margin-left: 0.25rem;
  padding-top: 4px;
}
.error {
  color: red;
  font-size: 14px;
  margin-top: 4px;
}
.success {
  color: green;
  font-size: 14px;
  margin-top: 4px;
}
.modal-default-button {
  background: #dae12f;
  color: #000000;
  border-radius: 4px;
  padding: 10px 25px;
  border: none;
  outline: none;
}
h1 {
  overflow: hidden;
  text-align: center;
}

h1:before,
h1:after {
  background-color: #dae12f;
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 50%;
  color: #dae12f;
}

h1:before {
  right: 0.5em;
  margin-left: -50%;
}

h1:after {
  left: 0.5em;
  margin-right: -50%;
}
</style>
